<template>
  <el-dialog :visible.sync="dialogVisible" v-el-drag-dialog append-to-body :close-on-click-modal="false" title="选择项目"
    width="46%">
    <vm-table ref="vmTable" :filter.sync="filter" module="basic" url="projects/getSelectList">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="项目编号">
            <el-input v-model.trim="filter.projectNo" placeholder="请输入" clearable />
          </vm-search>
          <vm-search label="项目名称">
            <el-input v-model.trim="filter.projectName" placeholder="请输入" clearable />
          </vm-search>
        </div>
      </template>
      <el-table-column prop="projectNo" align="center" label="项目编号" width="120" />
      <el-table-column prop="projectName" label="项目名称" show-overflow-tooltip />
      <el-table-column prop="projectMangerName" align="center" label="项目经理" width="120" />
      <el-table-column prop="status" align="center" label="状态" width="120">
        <template slot-scope="scope">
          <el-tag type="info" effect="dark" v-if="scope.row.status === 1">未启动</el-tag>
          <el-tag effect="dark" v-else-if="scope.row.status === 2">进行中</el-tag>
          <el-tag type="success" effect="dark" v-else-if="scope.row.status === 3">已完成</el-tag>
          <el-tag type="danger" effect="dark" v-else>挂起</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="80">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
import VmTable from "@/components/VmTable.vue";
import VmSearch from "@/components/VmSearch.vue";
import constant from "@/util/constant";
export default {
  name: "ProgramSelect",
  components: { VmTable, VmSearch },
  data() {
    return {
      constant,
      dialogVisible: false,
      submitLoading: false,
      filter: {
        projectNo: "",
        projectName: ""
      },
    };
  },
  methods: {
    open() {
      this.filter = {};
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.getList(1);
      });
    },

    getList(pageNum) {
      this.$refs.vmTable.getList(pageNum);
    },

    onSelect(row) {
      this.$emit("select", row);
      this.dialogVisible = false;
    },
  },
};
</script>
